import React, { forwardRef } from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { Paper } from '@vk-hr-tek/ui/Paper';
import { ChipsInput } from '@vk-hr-tek/ui/input/ChipsInput';

import { ListBoxCategory } from './ListBox';

export const GroupFilter = forwardRef<
  HTMLDivElement,
  {
    categories: ListBoxCategory[];
    currentCategory: string;
    onChangeCategory: (category: string) => void;
    showResult: boolean;
    children?: React.ReactNode | React.ReactNode[];
  }
>(
  (
    {
      categories,
      currentCategory,
      onChangeCategory,
      showResult,
      children,
      ...rest
    },
    ref,
  ) => {
    const preventCloseDropdown = (
      event: React.MouseEvent<HTMLElement, MouseEvent>,
    ) => {
      event.preventDefault();
      event.stopPropagation();
    };

    return (
      <Paper ref={ref} {...rest}>
        {!!categories.length && (
          <Box
            p="16"
            onMouseDown={preventCloseDropdown}
            borderBottom={showResult ? 1 : 0}
            borderColor="stroke.primary"
          >
            <ChipsInput
              size="small"
              items={categories}
              value={currentCategory}
              onChange={(value) => onChangeCategory(value as string)}
            />
          </Box>
        )}
        {children}
      </Paper>
    );
  },
);
